/**
 * Kanban CSS Constants
 */
/** @hidden */
export var ROOT_CLASS = 'e-kanban';
/** @hidden */
export var RTL_CLASS = 'e-rtl';
/** @hidden */
export var DEVICE_CLASS = 'e-device';
/** @hidden */
export var ICON_CLASS = 'e-icons';
/** @hidden */
export var TEMPLATE_CLASS = 'e-template';
/** @hidden */
export var SWIMLANE_CLASS = 'e-swimlane';
/** @hidden */
export var TABLE_CLASS = 'e-kanban-table';
/** @hidden */
export var HEADER_CLASS = 'e-kanban-header';
/** @hidden */
export var HEADER_TABLE_CLASS = 'e-header-table';
/** @hidden */
export var HEADER_CELLS_CLASS = 'e-header-cells';
/** @hidden */
export var HEADER_WRAP_CLASS = 'e-header-wrap';
/** @hidden */
export var HEADER_TITLE_CLASS = 'e-header-title';
/** @hidden */
export var HEADER_TEXT_CLASS = 'e-header-text';
/** @hidden */
export var HEADER_ICON_CLASS = 'e-header-icon';
/** @hidden */
export var STACKED_HEADER_ROW_CLASS = 'e-stacked-header-row';
/** @hidden */
export var STACKED_HEADER_CELL_CLASS = 'e-stacked-header-cell';
/** @hidden */
export var CONTENT_CELLS_CLASS = 'e-content-cells';
/** @hidden */
export var CONTENT_CLASS = 'e-kanban-content';
/** @hidden */
export var CONTENT_TABLE_CLASS = 'e-content-table';
/** @hidden */
export var HEADER_ROW_TOGGLE_CLASS = 'e-toggle-header';
/** @hidden */
export var HEADER_ROW_CLASS = 'e-header-row';
/** @hidden */
export var CONTENT_ROW_CLASS = 'e-content-row';
/** @hidden */
export var SWIMLANE_ROW_CLASS = 'e-swimlane-row';
/** @hidden */
export var SWIMLANE_ROW_EXPAND_CLASS = 'e-swimlane-row-expand';
/** @hidden */
export var SWIMLANE_ROW_COLLAPSE_CLASS = 'e-swimlane-row-collapse';
/** @hidden */
export var SWIMLANE_ROW_TEXT_CLASS = 'e-swimlane-text';
/** @hidden */
export var CARD_ITEM_COUNT_CLASS = 'e-item-count';
/** @hidden */
export var CARD_WRAPPER_CLASS = 'e-card-wrapper';
/** @hidden */
export var CARD_CLASS = 'e-card';
/** @hidden */
export var CARD_HEADER_CLASS = 'e-card-header';
/** @hidden */
export var CARD_CONTENT_CLASS = 'e-card-content';
/** @hidden */
export var CARD_HEADER_TEXT_CLASS = 'e-card-header-caption';
/** @hidden */
export var CARD_HEADER_TITLE_CLASS = 'e-card-header-title';
/** @hidden */
export var COLUMN_EXPAND_CLASS = 'e-column-expand';
/** @hidden */
export var COLUMN_COLLAPSE_CLASS = 'e-column-collapse';
/** @hidden */
export var COLLAPSE_HEADER_TEXT_CLASS = 'e-collapse-header-text';
/** @hidden */
export var COLLAPSED_CLASS = 'e-collapsed';
/** @hidden */
export var DIALOG_CLASS = 'e-kanban-dialog';
/** @hidden */
export var DIALOG_CONTENT_CONTAINER_CLASS = 'e-kanban-dialog-content';
/** @hidden */
export var FORM_CLASS = 'e-kanban-form';
/** @hidden */
export var FORM_WRAPPER_CLASS = 'e-kanban-form-wrapper';
/** @hidden */
export var ERROR_VALIDATION_CLASS = 'e-kanban-error';
/** @hidden */
export var FIELD_CLASS = 'e-field';
/** @hidden */
export var DRAGGED_CLONE_CLASS = 'e-target-dragged-clone';
/** @hidden */
export var CLONED_CARD_CLASS = 'e-cloned-card';
/** @hidden */
export var DRAGGED_CARD_CLASS = 'e-kanban-dragged-card';
/** @hidden */
export var DROPPED_CLONE_CLASS = 'e-target-dropped-clone';
/** @hidden */
export var DROPPING_CLASS = 'e-dropping';
/** @hidden */
export var TOGGLE_VISIBLE_CLASS = 'e-toggle-visible';
/** @hidden */
export var MULTI_CLONE_CONTENT_CELL_CLASS = 'e-multi-content-cell';
/** @hidden */
export var MULTI_CARD_WRAPPER_CLASS = 'e-multi-card-wrapper';
/** @hidden */
export var MULTI_ACTIVE_CLASS = 'e-multi-active';
/** @hidden */
export var TARGET_MULTI_CLONE_CLASS = 'e-target-multi-clone';
/** @hidden */
export var MULTI_COLUMN_KEY_CLASS = 'e-column-key';
/** @hidden */
export var CARD_SELECTION_CLASS = 'e-selection';
/** @hidden */
export var TOOLTIP_CLASS = 'e-kanban-tooltip';
/** @hidden */
export var TOOLTIP_TEXT_CLASS = 'e-tooltip-text';
/** @hidden */
export var SCROLL_CONTAINER_CLASS = 'e-cell-scroll-container';
/** @hidden */
export var SWIMLANE_HEADER_CLASS = 'e-swimlane-header';
/** @hidden */
export var SWIMLANE_HEADER_TOOLBAR_CLASS = 'e-swimlane-header-toolbar';
/** @hidden */
export var TOOLBAR_MENU_CLASS = 'e-toolbar-menu';
/** @hidden */
export var TOOLBAR_MENU_ICON_CLASS = 'e-icon-menu';
/** @hidden */
export var TOOLBAR_LEVEL_TITLE_CLASS = 'e-toolbar-level-title';
/** @hidden */
export var TOOLBAR_SWIMLANE_NAME_CLASS = 'e-toolbar-swimlane-name';
/** @hidden */
export var SWIMLANE_OVERLAY_CLASS = 'e-swimlane-overlay';
/** @hidden */
export var SWIMLANE_CONTENT_CLASS = 'e-swimlane-content';
/** @hidden */
export var SWIMLANE_RESOURCE_CLASS = 'e-swimlane-resource';
/** @hidden */
export var SWIMLANE_TREE_CLASS = 'e-swimlane-tree';
/** @hidden */
export var LIMITS_CLASS = 'e-limits';
/** @hidden */
export var MAX_COUNT_CLASS = 'e-max-count';
/** @hidden */
export var MIN_COUNT_CLASS = 'e-min-count';
/** @hidden */
export var MAX_COLOR_CLASS = 'e-max-color';
/** @hidden */
export var MIN_COLOR_CLASS = 'e-min-color';
/** @hidden */
export var POPUP_EVENT_CLASS = 'e-event-popup';
/** @hidden */
export var POPUP_HEADER_CLASS = 'e-popup-header';
/** @hidden */
export var CLOSE_CLASS = 'e-close';
/** @hidden */
export var POPUP_CONTENT_CLASS = 'e-popup-content';
/** @hidden */
export var POPUP_WRAPPER_CLASS = 'e-mobile-popup-wrapper';
/** @hidden */
export var CLOSE_ICON_CLASS = 'e-close-icon';
/** @hidden */
export var POPUP_OPEN_CLASS = 'e-popup-open';
/** @hidden */
export var DIALOG_CONTENT_CONTAINER = 'e-kanban-dialog-content';
/** @hidden */
export var SHOW_ADD_BUTTON = 'e-show-add-button';
/** @hidden */
export var SHOW_ADD_ICON = 'e-show-add-icon';
